import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import store from "store";
import { useAppDispatch } from "../Hooks/redux";
import { loginSuccess, meRequest } from "../Redux/AuthRedux";
import Api from "../Services/Api";
import AppHeader from "./AppHeader";

const api = Api.create();

/**
 * /success — shown after a successful Stripe Payment Link checkout.
 * Stripe's post-payment redirect on the Payment Link is configured in the
 * Stripe dashboard (Payment Links → Confirmation → Custom URL).
 */
export default function SuccessPage() {
  const [params] = useSearchParams();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const token = params.get("token");
    if (!token) return;
    store.set("token", token);
    api.setAuthToken(token);
    dispatch(loginSuccess({ user: null, token }));
    dispatch(meRequest({ callback: () => {} }));
    window.history.replaceState({}, "", "/success");
  }, [params, dispatch]);

  return (
    <div className="min-h-screen bg-slate-50">
      <AppHeader />
      <div className="max-w-lg mx-auto mt-12 bg-white border border-slate-200 rounded-xl shadow-sm p-8 text-center">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-emerald-100 text-emerald-600 text-3xl mb-4">
          ✓
        </div>
        <h1 className="text-2xl font-extrabold text-slate-900 mb-2">
          Payment successful — your scan is queued
        </h1>
        <p className="text-sm text-slate-500 mb-6">
          Thanks! We&apos;ve kicked off your SeoSonar scan. Your full report will be
          emailed to your inbox within{" "}
          <span className="font-semibold text-slate-900">24 hours</span>.
          You can safely close this page.
        </p>

        <div className="bg-slate-50 border border-slate-200 rounded-lg p-5 text-left mb-6">
          <div className="text-sm font-semibold text-slate-900 mb-3">What to expect in your inbox</div>
          <ul className="text-sm text-slate-600 space-y-2 list-disc list-inside">
            <li>20+ scored experiments ranked by impact</li>
            <li>Exact title &amp; meta rewrites you can paste in</li>
            <li>New page opportunities from keyword gaps</li>
            <li>A Claude prompt for each fix so you can ship it fast</li>
          </ul>
        </div>

        <p className="text-xs text-slate-400">
          Didn&apos;t receive an email in 24 hours? Reply to your Stripe receipt and we&apos;ll jump on it — no-questions-asked refund if it&apos;s not useful.
        </p>

        <Link
          to="/"
          className="inline-block mt-6 text-sm text-indigo-600 font-semibold hover:underline"
        >
          Back to home
        </Link>
      </div>
    </div>
  );
}
